import $ from "jquery";
import alertElica from "./alert";

export default function () {
    $("#products_form").submit(function (e) {
        e.preventDefault();

        let elem = $('#productsAccordion .accordion-collapse[data-id=' + window.lastProduct + ']').parents('.accordion-item').get(0);

        //save product before clone
        let data = new FormData();
        let inputElements = $(elem).find("input,select,textarea").serializeArray();
        for (var key in inputElements) {
            data.append($("[name=" + inputElements[key].name + "]").data("name"), inputElements[key].value);
        }

        //File data
        var file_data = $(elem).find('input[data-name="receipt"]').get(0).files;
        for (var i = 0; i < file_data.length; i++) {
            data.append("receipt", file_data[i]);
        }

        if (elem.dataset.saved === "true") {
            //dico al backend di non salvare di nuovo il prodotto
            data.append("already_saved", true);
        }

        $.ajax({
            url: saveProductUrl,
            method: "POST",
            data: data,
            processData: false,
            contentType: false,
            success: function (result) {
                let elem = $('#productsAccordion .accordion-collapse[data-id=' + window.lastProduct + ']').parents('.accordion-item').get(0);
                elem.setAttribute('data-saved', true);

                //tracciamenti
                let data = {
                    event: 'ga4_event',
                    event_name: 'product_registration',
                    step_number: '2',
                    nc_code: '',
                    purchase_date: '',
                    product_type: '',
                }
                result.products.forEach(product => {
                    data.nc_code = product.code_12nc ?? '';
                    data.purchase_date = product.purchase_date ?? '';
                    data.product_type = product.name ?? '';
                    const events = new CustomEvent('DataLayerEventPush', {
                        detail: { data: data }
                    });
                    window.dispatchEvent(events);
                })

                window.location.href = confirmationUrl;
            },
            error: function (xhr) {
                let elem = $('#productsAccordion .accordion-collapse[data-id=' + window.lastProduct + ']').parents('.accordion-item').get(0);

                let response = JSON.parse(xhr.responseText);
                if (typeof response['errors'] !== "undefined") {
                    for (var key in response['errors']) {
                        if (!$(elem).find('[data-name=' + key + ']:eq(0)').hasClass('is-invalid')) {
                            $(elem).find('[data-name=' + key + ']:eq(0)').addClass('is-invalid').after(
                                '<div id="validation' + key + 'Feedback" class="invalid-feedback">' +
                                response['errors'][key] +
                                '</div>'
                            );
                        }
                    }
                }
                if (typeof response['error'] !== "undefined") {
                    alertElica(response['message']);
                    window.location.href = homeUrl;
                }

                if ($("#productsAccordion .is-invalid").length) {
                    $("#productsAccordion .is-invalid").parents('.accordion-item').children('h4:not(.active)').children('button.accordion-button').click();
                    alertElica(translations.fixErrorsMsg);
                    $('html,body').animate({
                        scrollTop: $("#productsAccordion .is-invalid:first").parents('.accordion-item').offset().top
                    }, 'slow');
                    return false;
                }
            }
        });
    });
}
